import { DataBean } from "../DataBean";

export class FactoryDocument extends DataBean {


    public async getDocumentFactoryCatalog(processType:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getDocumentFactoryCatalog_Number", [processType]);
    }


}